/**
 * @description 新增小区和编辑小区的公共参数以及方法
 * 
 * @function getTradeAreaList 需要传入区域areaid 所以需要放在查询详情之后
 */

import { Message } from 'element-ui';
import { areaQuery, tradeareaQuery, } from "@/api/manageCenter.js";
import { dicGet } from "@/api";

const Community = {
    data() {
        return {
            arr: [], //建筑类型
            arr2: [], //停车方式
            rName: "",
            aName: "",
            dialogVisible: false,
            regionData: [], //区域列表
            tradAreaData: [], //商圈列表
            buildTypeD: [], //建筑类型列表
            parkingWay: [], //停车方式列表
            powerSupplyWay: [], //商业供电列表
            waterSupplyWay: [], //商业供水列表
            gasSupplyWay: [], //商业供气列表
            heatingWay: [], //商业供暖列表
            communiName: "",
            lng: "",
            lat: "",
            communityInfo: {
                address: "", //地址
                areaId: "", //区域
                tradeAreaId: "", //商圈
                name: "", //小区名称
                longitude: "",
                latitude: "",
                avgPrice: "", // 小区均价
                builds: "", // 小区栋数
                households: "", // 总户数
                developers: "", // 开发商
                propertyCompany: "", // 物业公司
                propertyFee: "", // 物业费
                propertyPhone: "", // 物业电话
                areaCovered: "", // 占地面积
                buildingCovered: "", // 建筑总面积
                greenRate: "", // 绿化率
                volumeRate: "", // 容积率
                parkingSpaces: "", // 车位数量
                parkingFee: "", // 停车费
                powerSupplyMode: "", // 供电方式
                powerFee: "", // 电费
                waterSupplyMode: "", // 供水方式
                waterFee: "", // 水费
                gasSupplyMode: "", // 供气方式
                gasFee: "", // 天然气费
                warmSupplyModel: "", // 供暖方式
                warmFee: "", // 暖气费
                description: "", // 楼盘介绍,
                architecturalType: [], // 建筑类型
                parkingMode: [] // 停车方式
            },
        }
    },
    mounted() {
        this.getRegionList(true);
        this.getPowerSupplyWay(true);
        this.getWaterSupplyWay(true);
        this.getGasSupplyWay(true);
        this.getHeatingWay(true);
        this.getBuildTypeData();
        this.getParkingWay();
    },
    methods: {
        getRegionList(val) {
            // 查询区域列表
            if (val) {
                this.$post(areaQuery).then(res => {
                    if (res.success) {
                        this.regionData = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            }
        },

        getTradeAreaList(val) {
            // 商圈列表
            if (val) {
                let params = {
                    areaId: this.communityInfo.areaId
                };
                this.$post(tradeareaQuery, params).then(res => {
                    if (res.success) {
                        this.tradAreaData = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            }
        },


        getBuildTypeData() {
            // 查询建筑类型
            let params = {
                code: "areaArchitecturalType"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    //cosole.log(res, "建筑类型");
                    this.buildTypeD = res.data;
                }
            });
        },

        getParkingWay() {
            // 查询停车方式
            let params = {
                code: "parkingMode"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    //cosole.log(res, "停车方式");
                    this.parkingWay = res.data;
                }
            });
        },

        getPowerSupplyWay(val) {
            // 查询供电方式
            if (val) {
                let params = {
                    code: "powerSupplyMode"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res, "供电方式");
                        this.powerSupplyWay = res.data;
                    }
                });
            }
        },

        getWaterSupplyWay(val) {
            // 查询供水方式
            if (val) {
                let params = {
                    code: "waterSupplyMode"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res, "供水方式");
                        this.waterSupplyWay = res.data;
                    }
                });
            }
        },

        getGasSupplyWay(val) {
            // 查询供气方式
            if (val) {
                let params = {
                    code: "gasSupplyMode"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res, "供气方式");
                        this.gasSupplyWay = res.data;
                    }
                });
            }
        },

        getHeatingWay(val) {
            // 查询供暖方式
            if (val) {
                let params = {
                    code: "warmSupplyModel"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res, "供暖方式");
                        this.heatingWay = res.data;
                    }
                });
            }
        },
    }
}

export default Community